import { FormattedMessage } from 'react-intl';

const Release600 = () => (
    <div style={{ marginLeft: '110px' }}>
        <p className="text-bold text-size-18 margin-bottom-5">
            <FormattedMessage id="help.changelog.6.0.0.newDriverRatings" />
        </p>
        <p className="margin-top-0 margin-bottom-5">
            <FormattedMessage id="help.changelog.6.0.0.newDriverRatings.shortDetail" />
        </p>
        <ul>
            <li>
                <FormattedMessage id="help.changelog.6.0.0.newDriverRatings.accelerationPedal" />
            </li>
            <li>
                <FormattedMessage id="help.changelog.6.0.0.newDriverRatings.recuperation" />
            </li>
        </ul>
        <p className="text-bold text-size-18 margin-bottom-5">
            <FormattedMessage id="help.changelog.6.0.0.recommendations" />
        </p>
        <p className="margin-top-0 margin-bottom-5">
            <FormattedMessage id="help.changelog.6.0.0.recommendations.shortDetail" />
        </p>
    </div>
);

export default Release600;
